import Add from './add';
import Alert from './alert';
import ApartamentRoom from './apartament-room';
import ArrowCircleRight from './arrow-circle-right';
import ArrowDown from './arrow-down';
import ArrowDownFilled from './arrow-down-filled';
import ArrowLeft from './arrow-left';
import ArrowLeftBig from './arrow-left-big';
import ArrowRight from './arrow-right';
import ArrowUp from './arrow-up';
import ArrowUpFilled from './arrow-up-filled';
import BankAddress from './bank-address';
import Barifin from './barifin';
import Bariflex from './bariflex';
import Building from './building';
import Cancel from './cancel';
import CheckMark from './check-mark';
import CirclePlus from './circle-plus';
import Close from './close';
import CloseX from './closed-x';
import Completed from './completed';
import CopyClipboard from './copy-clipboard';
import Dashboard from './dashboard';
import Disclaimer from './disclaimer';
import Download from './download';
import EditPencil from './edit-pencil';
import Engine from './engine';
import Equal from './equal';
import Error from './error';
import Expand from './expand';
import ExternalLink from './external-link';
import EyeOpen from './eye-open';
import EyeClose from './eye-close';
import FileFilled from './file-filled';
import Folder from './folder';
import FolderPlus from './folder-plus';
import GiveUp from './give-up';
import HelpToolTip from './help-tool-tip';
import Home from './home';
import House from './house';
import Identification from './identification';
import Information from './information';
import Kebab from './kebab';
import Lock from './lock';
import Logout from './logout';
import MaritalStatus from './marital-status';
import Megaphone from './megaphone';
import ModalError from './modal-error';
import ModalSuccess from './modal-success';
import More from './more';
import Money from './money';
import MuchArrowLeft from './much-arrow-left';
import MuchArrowRight from './much-arrow-right';
import NaturalPeson from './natural-person';
import Others from './others';
import Party from './party';
import Person from './person';
import Price from './price';
import Printer from './printer';
import Profile from './profile';
import Redo from './redo';
import Residence from './residence';
import Rocket from './rocket';
import Sac from './sac';
import SearchZipCode from './search-zip-code';
import Search from './search';
import Success from './success';
import SuccessGreenSmall from './success-green-small';
import Terrain from './terrain';
import Trash from './trash';
import UsebensInsurance from './usebens-insurance';
import UserProfile from './user-profile';
import Video from './video';
import Warning from './warning';
import WarningOrangeSmall from './warning-orange-small';
import ZurichInsurance from './zurich-insurance';
import ErrorSmallRed from './error-small-red';
import SuccessGreenSmallNoFill from './success-green-small-no-fill';

import { Icons as IconsEnum } from '../../../enums/icons';

const Icons = {
  [IconsEnum.ADD]: Add,
  [IconsEnum.ALERT]: Alert,
  [IconsEnum.APARTMENT_ROOM]: ApartamentRoom,
  [IconsEnum.ARROW_CIRCLE_RIGHT]: ArrowCircleRight,
  [IconsEnum.ARROW_DOWN_FILLED]: ArrowDownFilled,
  [IconsEnum.ARROW_DOWN]: ArrowDown,
  [IconsEnum.ARROW_LEFT_BIG]: ArrowLeftBig,
  [IconsEnum.ARROW_LEFT]: ArrowLeft,
  [IconsEnum.ARROW_RIGHT]: ArrowRight,
  [IconsEnum.ARROW_UP_FILLED]: ArrowUpFilled,
  [IconsEnum.ARROW_UP]: ArrowUp,
  [IconsEnum.BANK_ADDRESS]: BankAddress,
  [IconsEnum.BARIFIN]: Barifin,
  [IconsEnum.BARIFLEX]: Bariflex,
  [IconsEnum.BUILDING]: Building,
  [IconsEnum.CANCEL]: Cancel,
  [IconsEnum.CHECK_MARK]: CheckMark,
  [IconsEnum.CIRCLE_PLUS]: CirclePlus,
  [IconsEnum.CLOSE]: Close,
  [IconsEnum.CLOSED_X]: CloseX,
  [IconsEnum.COMPLETED]: Completed,
  [IconsEnum.COPYCLIPBOARD]: CopyClipboard,
  [IconsEnum.DASHBOARD]: Dashboard,
  [IconsEnum.DISCLAIMER]: Disclaimer,
  [IconsEnum.DOWNLOAD]: Download,
  [IconsEnum.EDIT_PENCIL]: EditPencil,
  [IconsEnum.ENGINE]: Engine,
  [IconsEnum.EQUAL]: Equal,
  [IconsEnum.ERROR_SMALL_RED]: ErrorSmallRed,
  [IconsEnum.ERROR]: Error,
  [IconsEnum.EXPAND]: Expand,
  [IconsEnum.EXTERNAL_LINK]: ExternalLink,
  [IconsEnum.EYE_OPEN]: EyeOpen,
  [IconsEnum.EYE_CLOSE]: EyeClose,
  [IconsEnum.FILE_FILLED]: FileFilled,
  [IconsEnum.FOLDER]: Folder,
  [IconsEnum.FOLDER_PLUS]: FolderPlus,
  [IconsEnum.GIVE_UP]: GiveUp,
  [IconsEnum.HELP_TOOL_TIP]: HelpToolTip,
  [IconsEnum.HOME]: Home,
  [IconsEnum.HOUSE]: House,
  [IconsEnum.IDENTIFICATION]: Identification,
  [IconsEnum.INFORMATION]: Information,
  [IconsEnum.KEBAB]: Kebab,
  [IconsEnum.LOCK]: Lock,
  [IconsEnum.LOGOUT]: Logout,
  [IconsEnum.MARITAL_STATUS]: MaritalStatus,
  [IconsEnum.MEGAPHONE]: Megaphone,
  [IconsEnum.MODAL_ERROR]: ModalError,
  [IconsEnum.MODAL_SUCCESS]: ModalSuccess,
  [IconsEnum.MORE]: More,
  [IconsEnum.MONEY]: Money,
  [IconsEnum.MUCH_ARROW_LEFT]: MuchArrowLeft,
  [IconsEnum.MUCH_ARROW_RIGHT]: MuchArrowRight,
  [IconsEnum.NATURAL_PERSON]: NaturalPeson,
  [IconsEnum.OTHERS]: Others,
  [IconsEnum.PARTY]: Party,
  [IconsEnum.PERSON]: Person,
  [IconsEnum.PRICE]: Price,
  [IconsEnum.PRINTER]: Printer,
  [IconsEnum.PROFILE]: Profile,
  [IconsEnum.REDO]: Redo,
  [IconsEnum.RESIDENCE]: Residence,
  [IconsEnum.ROCKET]: Rocket,
  [IconsEnum.SAC]: Sac,
  [IconsEnum.SEARCH]: Search,
  [IconsEnum.SEARCH_ZIP_CODE]: SearchZipCode,
  [IconsEnum.SUCCESS_GREEN_SMALL_NO_FILL]: SuccessGreenSmallNoFill,
  [IconsEnum.SUCCESS_GREEN_SMALL]: SuccessGreenSmall,
  [IconsEnum.SUCCESS]: Success,
  [IconsEnum.TERRAIN]: Terrain,
  [IconsEnum.TRASH]: Trash,
  [IconsEnum.USEBENS_INSURANCE]: UsebensInsurance,
  [IconsEnum.USER_PROFILE]: UserProfile,
  [IconsEnum.VIDEO]: Video,
  [IconsEnum.WARNING_ORANGE_SMALL]: WarningOrangeSmall,
  [IconsEnum.WARNING]: Warning,
  [IconsEnum.ZURICH_INSURANCE]: ZurichInsurance
};

export const getIcon = (type: IconsEnum) => {
  return Icons[type];
};
